<!--  -->
<template>
  <div style="padding: 30px;">
    <!--    <div class="top_inrwe">-->
    <!--      <div class="container">-->
    <!--        <el-input></el-input>-->
    <!--        <el-button type="info">搜索</el-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <el-table
      border
      :data="templatedata"
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
        align="center"
      />
      <el-table-column
        prop="user_id"
        label="推广账户ID"
        align="center"
      />
      <el-table-column
        prop="update_token_id"
        label="openID"
        align="center"
      />
      <el-table-column
        prop="user_id"
        label="user_id"
        align="center"
      />
      <el-table-column
        prop="master_uid"
        label="同意授权用户ucid"
        align="center"
      />
      <el-table-column
        prop="master_name"
        label="同意授权用户ucname"
        align="center"
      />
      <el-table-column
        prop="token"
        label="token"
        align="center"
      />
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="fp_admin_id"
        label="操作"
        align="center"
        width="300px"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="synchronization(scope.row)"
          >同步子账号</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="updateToken(scope.row)"
          >修改token</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="修改token"
      :visible.sync="tokenView"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <editTokenView :update_token_id="update_token_id" :old_token="old_token" @updateList="list" @cancel="tokenView = false" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import editTokenView from '@/views/baiduAD/primaryAccount/components/editToken.vue'
import { baiduPrimaryAccountList, subUpdate } from '@/api/baiduAD'
export default {
  components: { editTokenView, PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        id: null
      },
      total: null,
      templatedata: [],
      dialogVisible: false,
      name: '',
      id: '',
      tokenView: false,
      update_token_id: '',
      old_token: ''
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    list() {
      baiduPrimaryAccountList({
        page: this.query.page,
        page_size: this.query.page_size,
        user_id: this.$route.query.id
      }).then(res => {
        this.templatedata = res.data.list
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    updateToken(val) {
      console.log(val)
      this.update_token_id = val.user_id
      this.old_token = val.token
      this.tokenView = true
    },
    synchronization(val) {
      this.loading
      subUpdate({ user_id: val.user_id }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 0) {
          this.$message.success(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.inptw {
  width: 200px;
}
.top_inrwe {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container > * {
  margin-right: 10px;
}
</style>
